
import axios from 'axios';

// 创建axios实例
const http = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL, // API的基础路径
  timeout: 10000, // 请求超时时间
});

// 添加请求拦截器
http.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么，例如设置token
  config.headers.Authorization = `Bearer ${localStorage.getItem('xthy_admin_token')}`; // 假设token存储在localStorage中
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});
// 添加响应拦截器
http.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  var data = response.data
  return data;
}, function (error) {
  // 对响应错误做点什么
  if (error.response && error.response.status === 401) {
    // 例如，处理401未授权的错误，可能需要重新登录等操作
    localStorage.removeItem('xthy_admin_token')
    localStorage.removeItem('xthy_admin_manager_info')
    location.reload()
    console.log('Unauthorized, please login again.');
  } else {
    return Promise.reject(error);
  }
});

export default http;